import React from "react";

export default function SubmissionStatus(props) {
    if (props.submission.deprecated) return <span className="badge badge-light">archived</span>;
    else if (props.submission.finalized) return <span className="badge badge-success">published</span>;
    else return <span className="badge badge-warning">draft</span>;
};